import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Landmark } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("OK");
      nav("/profile");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <Card className="p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="h-12 w-12 rounded-lg bg-primary flex items-center justify-center mb-3"><Landmark className="h-6 w-6 text-primary-foreground" /></div>
          <h1 className="font-heading text-2xl font-bold tracking-tight">{t("auth.loginTitle")}</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="password">{t("auth.password")}</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
          </div>
          <Button data-testid="login-submit" type="submit" className="w-full" disabled={loading}>{loading ? t("common.loading") : t("nav.login")}</Button>
        </form>
        <p className="mt-5 text-sm text-center text-muted-foreground">
          {t("auth.noAccount")} <Link to="/register" data-testid="to-register" className="text-primary font-semibold hover:underline">{t("nav.register")}</Link>
        </p>
      </Card>
    </div>
  );
}
